// #################################################### //
// ###########| Alert Confirmation interface |########## //
// #################################################### //

export interface AlertOptions {
    title?: string;
    message: string;
    buttons?: AlertButton[];
    class?: string;
    enableSpin?: boolean;
    /** Optional checkbox shown below the message. */
    checkbox?: AlertCheckbox;
}

export interface AlertButton {
    text: string;
    handler?: (...args: any[]) => any;
    class?: string;
    focused?: boolean;
    accent?: boolean;
}

/** Configuration for an optional checkbox inside the confirmation dialog. */
export interface AlertCheckbox {
    /** Label text displayed next to the checkbox. */
    label: string;
    /** Initial checked state (defaults to false). */
    checked?: boolean;
}